import { appDataReducerPaginationAndSearch } from './reducerMetadata';

function normalizeVersion(version) {
    if (!version) {
        return version;
    }

    // If version number is exactly 'major.minor.0', only show 'major.minor'.
    return version.replace(/^(\d+\.\d+)\.0$/i, '$1');
}

// Overview of all administrations
export function appDataReducerAdministrations(state, action) {
    const meta = appDataReducerPaginationAndSearch(action.administrations?.message?.meta);


    const administrations = (action.administrations?.message?.data || []).map((data) => ({
        id: data.id,
        type: data.type,
        name: data.name,
        online: data.online,
        activeChildren: data.children_active,
        activeChildrenChildminder: data.children_active_childminder,
        activeChildrenTsoOnly: data.children_active_tso_only,
        staffActiveTotal: data.staff_active_total,
        staffActiveType1: data.staff_active_type1,
        staffActiveType2: data.staff_active_type2,
        dbVersion: data.database_version,
        companyId: data.company_id,
        licenseId: data.license_id,
        dsn: data.dsn,
        erpVersion: data.erp_version,
        hubVersion: normalizeVersion(data.hub_version),
        youkoVersion: normalizeVersion(data.youko_version),
        firVersion: normalizeVersion(data.fir_version),
        environment: data.environment,
        latestSyncAt: data.latest_sync,
        latestSyncStatus: data.latest_sync_status,
        ssoProvisionedAt: data.sso_provisioned_at,
        konnectHostname: data.konnect_hostname ? data.konnect_hostname.replace('https://', '').replace(/\/$/, '') : '-',
        clusterNumber: data.cluster_number,
        hasEmployeeImport: data.has_employee_import,
        hasSsoEnabled: data.has_sso_enabled,
        packageLinks: data.package_links,
        externalId: data.external_id,
    }));

    return {
        meta,
        items: administrations,
    };
}

// Detail of one administration
export function appDataReducerAdministration(state, action) {
    const administrationDetail = action.administration.message.data;

    return {
        id: administrationDetail.id,
        type: administrationDetail.type,
        name: administrationDetail.name,
        companyId: administrationDetail.company_id,
        databaseName: administrationDetail.database_name,
        databaseUsername: administrationDetail.database_username,
        environment: administrationDetail.environment,
        createdAt: administrationDetail.created_at,
        updatedAt: administrationDetail.updated_at,
        latestSyncAt: administrationDetail.latest_sync,
        latestSyncStatus: administrationDetail.latest_sync_status,
        ssoProvisionedAt: administrationDetail.sso_provisioned_at,
        online: administrationDetail.online,
        activeChildren: administrationDetail.children_active,
        activeChildrenChildminder: administrationDetail.children_active_childminder,
        activeChildrenTsoOnly: administrationDetail.children_active_tso_only,
        staffActiveTotal: administrationDetail.staff_active_total,
        staffActiveType1: administrationDetail.staff_active_type1,
        staffActiveType2: administrationDetail.staff_active_type2,
        dbVersion: administrationDetail.database_version,
        licenseId: administrationDetail.license_id,
        dsn: administrationDetail.dsn,
        erpVersion: administrationDetail.erp_version,
        hubVersion: normalizeVersion(administrationDetail.hub_version),
        youkoVersion: normalizeVersion(administrationDetail.youko_version),
        firVersion: normalizeVersion(administrationDetail.fir_version),
        konnectHostname: administrationDetail.konnect_hostname,
        clusterNumber: administrationDetail.cluster_number,
        hasEmployeeImport: administrationDetail.has_employee_import,
        hasSsoEnabled: administrationDetail.has_sso_enabled,
        erpAdministrationId: administrationDetail.erp_administration_id,
        packageLinks: administrationDetail.package_links,
        externalId: administrationDetail.external_id,
    };
}

// New administration
export function appDataReducerNewAdministration(state, action) {
    return {
        resetNewAdministrationForm: action.administrationNew.resetNewAdministrationForm,
    };
}
